/* Encuentra tu talla · motor. Compara medidas de prenda en plano con la tabla de la prenda. No deduce la forma del
   cuerpo ni convierte tallas entre marcas. Funciones puras, probadas con node (fit-sep26/tests). */
(function (global) {
  'use strict';
  const ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
  const RANGE = { width: [25, 100], length: [25, 120] };
  const norm = value => {
    const s = String(value == null ? '' : value).trim().toUpperCase();
    return s === '2XL' ? 'XXL' : s === '3XL' ? 'XXXL' : s;
  };
  const round = n => Math.round(n * 10) / 10;
  // Acepta coma o punto decimal. '' o null es «sin dato»; lo que no es número devuelve NaN.
  function num(value) {
    if (value === '' || value === null || value === undefined) return null;
    const n = Number(String(value).trim().replace(',', '.'));
    return Number.isFinite(n) ? n : NaN;
  }
  function toCm(value, unit) {
    const n = num(value);
    if (n === null || Number.isNaN(n)) return n;
    return unit === 'in' ? round(n * 2.54) : n;
  }
  // Rango admitido en la unidad elegida, para los mensajes de error.
  function range(axis, unit) {
    const [min, max] = RANGE[axis];
    return unit === 'in' ? [Math.ceil(min / 2.54), Math.floor(max / 2.54)] : [min, max];
  }
  function check(axis, value, unit, required) {
    const n = num(value);
    if (n === null) return required ? { ok: false, error: 'required' } : { ok: true, value: null };
    const cm = unit === 'in' ? n * 2.54 : n;
    const [min, max] = RANGE[axis];
    if (Number.isNaN(n) || cm < min || cm > max) {
      const [rmin, rmax] = range(axis, unit);
      return { ok: false, error: 'range', min: rmin, max: rmax };
    }
    return { ok: true, value: round(cm) };
  }
  // Filas válidas, ordenadas por talla. Una tabla sirve si tiene dos filas o más y el ancho crece con la talla.
  function cleanRows(rows) {
    const seen = new Set();
    return (rows || [])
      .map(r => ({ ...r, size: norm(r.size), width: num(r.width), length: num(r.length) }))
      .filter(r => ORDER.includes(r.size) && !seen.has(r.size) && seen.add(r.size) &&
        Number.isFinite(r.width) && r.width >= RANGE.width[0] && r.width <= RANGE.width[1] &&
        Number.isFinite(r.length) && r.length >= RANGE.length[0] && r.length <= RANGE.length[1])
      .sort((a, b) => ORDER.indexOf(a.size) - ORDER.indexOf(b.size));
  }
  function validRows(rows) {
    const r = cleanRows(rows);
    return r.length >= 2 && !r.some((row, i) => i && (row.width <= r[i - 1].width || row.length < r[i - 1].length));
  }
  // width y length en cm (length puede ser null). preference: same | closer | roomier, siempre respecto a la prenda
  // de referencia del comprador, nunca como «una talla más» universal.
  function compare(rows, width, length, preference) {
    preference = preference || 'same';
    if (!validRows(rows)) return { kind: 'unverified' };
    if (!['same', 'closer', 'roomier'].includes(preference)) return { kind: 'invalid' };
    if (!Number.isFinite(width) || width < RANGE.width[0] || width > RANGE.width[1] ||
        (length !== null && (!Number.isFinite(length) || length < RANGE.length[0] || length > RANGE.length[1]))) return { kind: 'invalid' };
    const r = cleanRows(rows);
    if (width < r[0].width - 2 || width > r[r.length - 1].width + 2) {
      // Fuera de la tabla: se devuelve la talla del extremo más cercano para poder decir cuánto cambia.
      const below = width < r[0].width, edge = below ? r[0] : r[r.length - 1];
      return { kind: 'outside_range', width, length, preference, side: below ? 'below' : 'above',
        closest: { ...edge, deltaWidth: round(edge.width - width), deltaLength: length === null ? null : round(edge.length - length) } };
    }
    const ranked = r.map(row => ({ ...row, deltaWidth: round(row.width - width), deltaLength: length === null ? null : round(row.length - length) }));
    const eligible = ranked.filter(x => preference === 'same' || (preference === 'roomier' ? x.deltaWidth > 0.2 : x.deltaWidth < -0.2));
    if (!eligible.length) return { kind: 'outside_preference', width, length, preference };
    eligible.sort((a, b) => Math.abs(a.deltaWidth) - Math.abs(b.deltaWidth) || Math.abs(a.deltaLength || 0) - Math.abs(b.deltaLength || 0));
    const choices = eligible.slice(0, 2);
    // Dos tallas casi igual de cerca no se convierten en una recomendación única.
    const between = choices.length > 1 && Math.abs(choices[0].deltaWidth) > 0.2 &&
      Math.abs(Math.abs(choices[0].deltaWidth) - Math.abs(choices[1].deltaWidth)) <= 0.75;
    const ordered = between ? [...choices].sort((a, b) => a.width - b.width) : choices;
    return { kind: between ? 'between' : 'nearest', choices: ordered, width, length, preference,
      lengthMismatch: length !== null && Math.abs(choices[0].deltaLength) > 3 };
  }
  // La talla dentro de un título de variante («Oversize / Off White / L» → L), o null.
  function sizeFromTitle(title, sizes) {
    const wanted = (sizes || ORDER).map(norm);
    const parts = String(title || '').split('/').map(p => norm(p));
    return parts.find(p => wanted.includes(p)) || null;
  }
  const api = Object.freeze({ ORDER, RANGE, norm, num, toCm, range, check, cleanRows, validRows, compare, sizeFromTitle });
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else global.AtelierFitCore = api;
})(typeof window === 'undefined' ? globalThis : window);
